module.exports = __webpack_public_path__ + "static/media/006ty@4x.de9ca357.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/006ty@4x.png
// module id = 413
// module chunks = 0 1